const searchicon = (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1505)">
			<path
				d="M5.52515 14.1478L2.76267 16.9103"
				stroke="#3DB8A9"
				stroke-width="1.5798"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.2155 16.1046C6.79867 16.1046 4.02874 13.3346 4.02874 9.91776C4.02874 6.50088 6.79867 3.73096 10.2155 3.73096C13.6324 3.73096 16.4023 6.50088 16.4023 9.91776C16.4023 13.3346 13.6324 16.1046 10.2155 16.1046Z"
				stroke="black"
				stroke-width="1.5798"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1505">
				<rect
					width="19.7978"
					height="19.7978"
					fill="white"
					transform="matrix(-1 0 0 1 19.7979 0.101074)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const mapmarker = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1515)">
			<path
				d="M9.29773 9.76562C10.4713 9.76562 11.4227 8.81423 11.4227 7.64062C11.4227 6.46702 10.4713 5.51562 9.29773 5.51562C8.12412 5.51562 7.17273 6.46702 7.17273 7.64062C7.17273 8.81423 8.12412 9.76562 9.29773 9.76562Z"
				stroke="black"
				stroke-width="1.0625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.29773 9.76562C10.4713 9.76562 11.4227 8.81423 11.4227 7.64062C11.4227 6.46702 10.4713 5.51562 9.29773 5.51562C8.12412 5.51562 7.17273 6.46702 7.17273 7.64062C7.17273 8.81423 8.12412 9.76562 9.29773 9.76562Z"
				stroke="#3DB8A9"
				stroke-width="1.0625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.6102 7.64062C14.6102 12.4219 9.29773 16.1406 9.29773 16.1406C9.29773 16.1406 3.98523 12.4219 3.98523 7.64062C3.98523 6.23166 4.54494 4.88041 5.54122 3.88412C6.53751 2.88783 7.88877 2.32813 9.29773 2.32812C10.7067 2.32813 12.0579 2.88783 13.0542 3.88412C14.0505 4.88041 14.6102 6.23166 14.6102 7.64062Z"
				stroke="black"
				stroke-width="1.0625"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1515">
				<rect
					width="17"
					height="17"
					fill="white"
					transform="translate(0.797729 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const dollar = (
	<svg
		width="21"
		height="20"
		viewBox="0 0 21 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1525)">
			<path
				d="M10.7977 1.875V3.75"
				stroke="black"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.7977 1.875V3.75"
				stroke="#3DB8A9"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.7977 16.25V18.125"
				stroke="black"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.7977 16.25V18.125"
				stroke="#3DB8A9"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M15.1727 6.875C15.1727 6.46462 15.0919 6.05826 14.9349 5.67911C14.7778 5.29997 14.5476 4.95547 14.2574 4.66529C13.9673 4.37511 13.6228 4.14492 13.2436 3.98788C12.8645 3.83083 12.4581 3.75 12.0477 3.75H9.54773C8.71893 3.75 7.92407 4.07924 7.33802 4.66529C6.75197 5.25134 6.42273 6.0462 6.42273 6.875C6.42273 7.7038 6.75197 8.49866 7.33802 9.08471C7.92407 9.67076 8.71893 10 9.54773 10H12.6727C13.5015 10 14.2964 10.3292 14.8824 10.9153C15.4685 11.5013 15.7977 12.2962 15.7977 13.125C15.7977 13.9538 15.4685 14.7487 14.8824 15.3347C14.2964 15.9208 13.5015 16.25 12.6727 16.25H8.92273C8.09393 16.25 7.29907 15.9208 6.71302 15.3347C6.12697 14.7487 5.79773 13.9538 5.79773 13.125"
				stroke="black"
				stroke-width="1.25"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1525">
				<rect
					width="20"
					height="20"
					fill="white"
					transform="translate(0.797729)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const searchicon2 = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1499)">
			<path
				d="M12.3301 18.3081C8.90421 18.3081 6.12698 15.5309 6.12698 12.105C6.12698 8.67908 8.90421 5.90186 12.3301 5.90186C15.756 5.90186 18.5332 8.67908 18.5332 12.105C18.5332 15.5309 15.756 18.3081 12.3301 18.3081Z"
				stroke="currentColor"
				stroke-width="1.41839"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M7.62732 16.3462L4.85756 19.116"
				stroke="currentColor"
				stroke-width="1.41839"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1499">
				<rect
					width="22.8187"
					height="22.4622"
					rx="4"
					transform="matrix(-1 0 0 1 23.4696 0.671875)"
					fill="currentColor"
				/>
			</clipPath>
		</defs>
	</svg>
);
const calendar = (
	<svg
		width="16"
		height="24"
		viewBox="0 0 16 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g filter="url(#filter0_b_2585_1572)">
			<path
				d="M12 5.6H15.2C15.4122 5.6 15.6157 5.68429 15.7657 5.83431C15.9157 5.98434 16 6.18783 16 6.4V19.2C16 19.4122 15.9157 19.6157 15.7657 19.7657C15.6157 19.9157 15.4122 20 15.2 20H0.8C0.587827 20 0.384344 19.9157 0.234315 19.7657C0.0842854 19.6157 0 19.4122 0 19.2V6.4C0 6.18783 0.0842854 5.98434 0.234315 5.83431C0.384344 5.68429 0.587827 5.6 0.8 5.6H4V4H5.6V5.6H10.4V4H12V5.6ZM10.4 7.2H5.6V8.8H4V7.2H1.6V10.4H14.4V7.2H12V8.8H10.4V7.2ZM14.4 12H1.6V18.4H14.4V12ZM3.2 14.4H4.8V16H3.2V14.4ZM6.4 14.4H12.8V16H6.4V14.4Z"
				fill="#4D4B4A"
				fill-opacity="0.86"
			/>
		</g>
		<defs>
			<filter
				id="filter0_b_2585_1572"
				x="-10"
				y="-10"
				width="36"
				height="44"
				filterUnits="userSpaceOnUse"
				color-interpolation-filters="sRGB"
			>
				<feFlood flood-opacity="0" result="BackgroundImageFix" />
				<feGaussianBlur in="BackgroundImageFix" stdDeviation="5" />
				<feComposite
					in2="SourceAlpha"
					operator="in"
					result="effect1_backgroundBlur_2585_1572"
				/>
				<feBlend
					mode="normal"
					in="SourceGraphic"
					in2="effect1_backgroundBlur_2585_1572"
					result="shape"
				/>
			</filter>
		</defs>
	</svg>
);
const star = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.2827 3.45332C11.5131 2.98638 11.6284 2.75291 11.7848 2.67831C11.9209 2.61341 12.0791 2.61341 12.2152 2.67831C12.3717 2.75291 12.4869 2.98638 12.7174 3.45332L14.9041 7.88328C14.9721 8.02113 15.0061 8.09006 15.0558 8.14358C15.0999 8.19096 15.1527 8.22935 15.2113 8.25662C15.2776 8.28742 15.3536 8.29854 15.5057 8.32077L20.397 9.03571C20.9121 9.11099 21.1696 9.14863 21.2888 9.27444C21.3925 9.38389 21.4412 9.5343 21.4215 9.68377C21.3988 9.85558 21.2124 10.0372 20.8395 10.4004L17.3014 13.8464C17.1912 13.9538 17.136 14.0076 17.1004 14.0715C17.0689 14.128 17.0487 14.1902 17.0409 14.2545C17.0321 14.3271 17.0451 14.403 17.0711 14.5547L17.906 19.4221C17.994 19.9355 18.038 20.1922 17.9553 20.3445C17.8833 20.477 17.7554 20.57 17.6071 20.5975C17.4366 20.6291 17.2061 20.5078 16.7451 20.2654L12.3724 17.9658C12.2361 17.8942 12.168 17.8584 12.0962 17.8443C12.0327 17.8318 11.9673 17.8318 11.9038 17.8443C11.832 17.8584 11.7639 17.8942 11.6277 17.9658L7.25492 20.2654C6.79392 20.5078 6.56341 20.6291 6.39297 20.5975C6.24468 20.57 6.11672 20.477 6.04474 20.3445C5.962 20.1922 6.00603 19.9355 6.09407 19.4221L6.92889 14.5547C6.95491 14.403 6.96793 14.3271 6.95912 14.2545C6.95132 14.1902 6.93111 14.128 6.89961 14.0715C6.86402 14.0076 6.80888 13.9538 6.69859 13.8464L3.16056 10.4004C2.78766 10.0372 2.60121 9.85558 2.57853 9.68377C2.55879 9.5343 2.60755 9.38389 2.71125 9.27444C2.83044 9.14863 3.08797 9.11099 3.60304 9.03571L8.49431 8.32077C8.64642 8.29854 8.72248 8.28742 8.78872 8.25662C8.84736 8.22935 8.90016 8.19096 8.94419 8.14358C8.99391 8.09006 9.02793 8.02113 9.09597 7.88328L11.2827 3.45332Z"
			fill="#A38FFF"
		/>
	</svg>
);
const searchIcon3 = (
	<svg
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1702)">
			<path
				d="M6.02502 14.6479L3.26255 17.4104"
				stroke="black"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M6.02502 14.6479L3.26255 17.4104"
				stroke="#CCADFF"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.7154 16.6047C7.29854 16.6047 4.52862 13.8348 4.52862 10.4179C4.52862 7.001 7.29854 4.23108 10.7154 4.23108C14.1323 4.23108 16.9022 7.001 16.9022 10.4179C16.9022 13.8348 14.1323 16.6047 10.7154 16.6047Z"
				stroke="black"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.7154 16.6047C7.29854 16.6047 4.52862 13.8348 4.52862 10.4179C4.52862 7.001 7.29854 4.23108 10.7154 4.23108C14.1323 4.23108 16.9022 7.001 16.9022 10.4179C16.9022 13.8348 14.1323 16.6047 10.7154 16.6047Z"
				stroke="#CCADFF"
				stroke-width="2.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1702">
				<rect
					width="19.7978"
					height="19.7978"
					fill="white"
					transform="matrix(-1 0 0 1 20.2977 0.601135)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const rightArrow = (
	<svg
		width="22"
		height="19"
		viewBox="0 0 22 19"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1817)">
			<path
				d="M8.5 3.5946L14.4375 9.5321L8.5 15.4696"
				stroke="white"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1817">
				<rect
					width="19"
					height="22"
					fill="white"
					transform="translate(0 19) rotate(-90)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const searchIcon4 = (
	<svg
		width="32"
		height="32"
		viewBox="0 0 32 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect x="0.5" y="0.5" width="31" height="31" rx="4.5" stroke="white" />
		<g clip-path="url(#clip0_42_325)">
			<path
				d="M16.6994 20.9351C13.4551 20.9351 10.8251 18.3051 10.8251 15.0608C10.8251 11.8165 13.4551 9.18652 16.6994 9.18652C19.9437 9.18652 22.5737 11.8165 22.5737 15.0608C22.5737 18.3051 19.9437 20.9351 16.6994 20.9351Z"
				stroke="black"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.2458 19.0771L9.62291 21.7001"
				stroke="black"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_42_325">
				<rect
					width="18.7978"
					height="18.7978"
					fill="white"
					transform="matrix(-1 0 0 1 25.7977 5.9624)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const user = (
	<svg
		width="23"
		height="23"
		viewBox="0 0 23 23"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_42_313)">
			<path
				d="M11.2794 14.5169C14.3759 14.5169 16.8861 12.0067 16.8861 8.91016C16.8861 5.81367 14.3759 3.30347 11.2794 3.30347C8.18293 3.30347 5.67273 5.81367 5.67273 8.91016C5.67273 12.0067 8.18293 14.5169 11.2794 14.5169Z"
				stroke="white"
				stroke-width="1.40167"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M2.86938 19.4227C4.56629 16.4906 7.64822 14.5168 11.2794 14.5168C14.9106 14.5168 17.9926 16.4906 19.6895 19.4227"
				stroke="white"
				stroke-width="1.40167"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_42_313">
				<rect
					width="22.4268"
					height="22.4268"
					fill="white"
					transform="translate(0.06604 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const doctor = (
	<svg
		width="20"
		height="21"
		viewBox="0 0 20 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1667)">
			<path
				d="M12.365 6.76923V7.01923H12.615H14.2712C14.8348 7.01923 15.3568 7.47455 15.5095 8.02643L16.7276 14.2002C16.7277 14.2006 16.7278 14.2009 16.7278 14.2012C16.873 14.9732 16.29 15.75 15.4043 15.75H4.50861C3.71989 15.75 3.1252 14.9832 3.27227 14.2012C3.27233 14.2009 3.27239 14.2006 3.27245 14.2002L4.49065 8.02643C4.64333 7.47455 5.16525 7.01923 5.72893 7.01923H7.38508H7.63508V6.76923V5.66154C7.63508 4.86284 8.23378 4.25 8.95406 4.25H11.046C11.7663 4.25 12.365 4.86284 12.365 5.66154V6.76923ZM11.7434 7.01923H11.9934V6.76923V5.66154C11.9934 5.40055 11.8723 5.15706 11.7072 4.9822C11.543 4.80827 11.3069 4.67308 11.046 4.67308H8.95406C8.69322 4.67308 8.45713 4.80827 8.29288 4.9822C8.12776 5.15706 8.00674 5.40055 8.00674 5.66154V6.76923V7.01923H8.25674H11.7434ZM12.615 12.5577H12.865V12.3077V10.4615V10.2115H12.615H11.1217V8.61538V8.36538H10.8717H9.12839H8.87839V8.61538V10.2115H7.38508H7.13508V10.4615V12.3077V12.5577H7.38508H8.87839V14.1538V14.4038H9.12839H10.8717H11.1217V14.1538V12.5577H12.615Z"
				fill="#9269D4"
				stroke="black"
				stroke-width="0.5"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1667">
				<rect
					width="20"
					height="20"
					fill="white"
					transform="translate(0 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);

const whatsapp = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.47322 2.98926H16.4451C18.9193 2.98926 20.9251 4.99508 20.9251 7.46923V16.4461C20.9251 18.9193 18.9193 20.9251 16.4451 20.9251H7.46923C4.99508 20.9251 2.98926 18.9193 2.98926 16.4451V7.47322C2.98926 4.99707 4.99707 2.98926 7.47322 2.98926V2.98926Z"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.61642 14.2949C11.7916 16.4711 14.5478 17.8581 16.1869 16.2259L16.5845 15.8284C17.1146 15.2993 17.0409 14.4224 16.4251 13.9949C16.0374 13.7249 15.6209 13.4349 15.1606 13.1111C14.6843 12.7763 14.0316 12.8291 13.6181 13.2386L13.1687 13.685C12.6117 13.3323 12.0607 12.8789 11.5485 12.3677L11.5465 12.3658C11.0353 11.8546 10.582 11.3026 10.2292 10.7456L10.6756 10.2962C11.0862 9.88364 11.137 9.22997 10.8032 8.75368C10.4783 8.29332 10.1884 7.87682 9.91933 7.4892C9.49186 6.8744 8.615 6.80067 8.08589 7.32977L7.68831 7.72735C6.05715 9.36649 7.44319 12.1206 9.61841 14.2978"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const mail = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.6908 21.922C18.1939 21.922 22.6551 17.4608 22.6551 11.9576C22.6551 6.45448 18.1939 1.99329 12.6908 1.99329C7.18763 1.99329 2.72644 6.45448 2.72644 11.9576C2.72644 17.4608 7.18763 21.922 12.6908 21.922Z"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.7885 17.0211C14.1019 17.3051 13.3905 17.4376 12.691 17.4376C9.66479 17.4376 7.21057 14.9834 7.21057 11.9572C7.21057 8.93103 9.66479 6.47681 12.691 6.47681C15.7171 6.47681 18.1714 8.93103 18.1714 11.9572V12.8699C18.1714 13.8156 17.4041 14.5818 16.4595 14.5818C15.5149 14.5818 14.7476 13.8146 14.7476 12.8699V11.9572C14.7476 10.8213 13.8279 9.90255 12.693 9.90255V9.90255C11.557 9.90255 10.6383 10.8223 10.6383 11.9572C10.6383 13.0921 11.558 14.0118 12.693 14.0118C13.8279 14.0118 14.7476 13.0931 14.7476 11.9572"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const instagram = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.93676 2.98926H16.9136C19.3868 2.98926 21.3926 4.99409 21.3926 7.46923V16.4461C21.3926 18.9193 19.3878 20.9251 16.9126 20.9251H7.93676C5.46261 20.9251 3.45679 18.9203 3.45679 16.4451V7.46923C3.45679 4.99508 5.46161 2.98926 7.93676 2.98926V2.98926Z"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.3564 6.68914C17.171 6.69014 17.0206 6.8406 17.0206 7.02594C17.0206 7.21127 17.172 7.36174 17.3574 7.36174C17.5427 7.36174 17.6932 7.21127 17.6932 7.02594C17.6942 6.8396 17.5427 6.68914 17.3564 6.68914"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.9612 9.42065C16.3621 10.8215 16.3621 13.0928 14.9612 14.4937C13.5603 15.8946 11.2891 15.8946 9.88818 14.4937C8.4873 13.0928 8.4873 10.8215 9.88818 9.42065C11.2891 8.01978 13.5603 8.01978 14.9612 9.42065"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const facebook = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.1584 21.922C17.6616 21.922 22.1228 17.4608 22.1228 11.9576C22.1228 6.45448 17.6616 1.99329 12.1584 1.99329C6.65528 1.99329 2.19409 6.45448 2.19409 11.9576C2.19409 17.4608 6.65528 21.922 12.1584 21.922Z"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M9.85071 11.2735H14.4652"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M14.4663 7.42859H13.6591C12.4066 7.42859 11.3903 8.44495 11.3903 9.69747V10.5046V16.4862"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const pinterest = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="24"
		viewBox="0 0 25 24"
		fill="none"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12.8923 21.9216C18.3955 21.9216 22.8567 17.4604 22.8567 11.9573C22.8567 6.45411 18.3955 1.99292 12.8923 1.99292C7.38917 1.99292 2.92798 6.45411 2.92798 11.9573C2.92798 17.4604 7.38917 21.9216 12.8923 21.9216Z"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M8.98822 11.9403C8.83776 11.5537 8.74011 11.1452 8.74011 10.7117C8.74011 8.64811 10.5995 6.9751 12.8923 6.9751C15.1851 6.9751 17.0444 8.64811 17.0444 10.7117C17.0444 12.7753 15.3714 14.4484 13.3078 14.4484C12.4857 14.4484 11.7324 14.1753 11.1156 13.7249"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M11.876 10.2733L10.4012 16.9395"
			stroke="black"
			stroke-width="1.49465"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const hamburger = (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_42_1128)">
			<path
				d="M3.5 21H24.5V18.6667H3.5V21ZM3.5 15.1667H24.5V12.8333H3.5V15.1667ZM3.5 7V9.33333H24.5V7H3.5Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_42_1128">
				<rect width="28" height="28" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
const filter = (
	<svg
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2067_3468)">
			<path
				d="M10.4167 18.75H14.5833V16.6667H10.4167V18.75ZM3.125 6.25V8.33333H21.875V6.25H3.125ZM6.25 13.5417H18.75V11.4583H6.25V13.5417Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2067_3468">
				<rect width="25" height="25" fill="white" />
			</clipPath>
		</defs>
	</svg>
);

const mapmarker2 = (
	<svg
		width="22"
		height="22"
		viewBox="0 0 22 22"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1843)">
			<path
				d="M10.9614 11.7498C12.4112 11.7498 13.5864 10.5836 13.5864 9.14498C13.5864 7.70638 12.4112 6.54017 10.9614 6.54017C9.51168 6.54017 8.33643 7.70638 8.33643 9.14498C8.33643 10.5836 9.51168 11.7498 10.9614 11.7498Z"
				stroke="black"
				stroke-width="1.05841"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.9614 11.7498C12.4112 11.7498 13.5864 10.5836 13.5864 9.14498C13.5864 7.70638 12.4112 6.54017 10.9614 6.54017C9.51168 6.54017 8.33643 7.70638 8.33643 9.14498C8.33643 10.5836 9.51168 11.7498 10.9614 11.7498Z"
				stroke="#9269D4"
				stroke-width="1.05841"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M17.5239 9.14498C17.5239 15.0058 10.9614 19.5642 10.9614 19.5642C10.9614 19.5642 4.39893 15.0058 4.39893 9.14498C4.39893 7.41788 5.09033 5.76152 6.32104 4.54028C7.55175 3.31904 9.22094 2.63296 10.9614 2.63296C12.7019 2.63296 14.3711 3.31904 15.6018 4.54028C16.8325 5.76152 17.5239 7.41788 17.5239 9.14498Z"
				stroke="black"
				stroke-width="1.05841"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1843">
				<rect
					width="21"
					height="20.8385"
					fill="white"
					transform="translate(0.461426 0.392059)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const dollar2 = (
	<svg
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1849)">
			<path
				d="M10.4614 2.68714V4.54771"
				stroke="black"
				stroke-width="1.24518"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.4614 2.68714V4.54771"
				stroke="#9269D4"
				stroke-width="1.24518"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.4614 16.9516V18.8121"
				stroke="black"
				stroke-width="1.24518"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.4614 16.9516V18.8121"
				stroke="#9269D4"
				stroke-width="1.24518"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M14.8364 7.64868C14.8364 7.24145 14.7556 6.83822 14.5985 6.46199C14.4415 6.08576 14.2113 5.74392 13.9211 5.45597C13.631 5.16801 13.2865 4.9396 12.9073 4.78376C12.5282 4.62792 12.1218 4.54772 11.7114 4.54772H9.21143C8.38262 4.54772 7.58777 4.87442 7.00172 5.45597C6.41567 6.03751 6.08643 6.82625 6.08643 7.64868C6.08643 8.4711 6.41567 9.25984 7.00172 9.84139C7.58777 10.4229 8.38262 10.7496 9.21143 10.7496H12.3364C13.1652 10.7496 13.9601 11.0763 14.5461 11.6579C15.1322 12.2394 15.4614 13.0282 15.4614 13.8506C15.4614 14.673 15.1322 15.4618 14.5461 16.0433C13.9601 16.6249 13.1652 16.9516 12.3364 16.9516H8.58643C7.75762 16.9516 6.96277 16.6249 6.37672 16.0433C5.79067 15.4618 5.46143 14.673 5.46143 13.8506"
				stroke="black"
				stroke-width="1.24518"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1849">
				<rect
					width="20"
					height="19.8462"
					fill="white"
					transform="translate(0.461426 0.826563)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const star2 = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1713)">
			<path
				d="M7.46141 10.3553L10.2402 12.0509C10.3123 12.0944 10.3957 12.1156 10.48 12.112C10.5642 12.1084 10.6455 12.0801 10.7136 12.0306C10.7816 11.9811 10.8333 11.9128 10.8623 11.8342C10.8912 11.7555 10.8959 11.6702 10.8759 11.5889L10.1203 8.42484L12.5934 6.30843C12.6564 6.25349 12.7019 6.18143 12.7241 6.10115C12.7464 6.02086 12.7445 5.93587 12.7186 5.85666C12.6927 5.77745 12.644 5.70749 12.5786 5.65542C12.5131 5.60335 12.4337 5.57145 12.3501 5.56366L9.10469 5.30163L7.85445 2.29835C7.82258 2.22086 7.76817 2.15456 7.69817 2.10789C7.62817 2.06121 7.54574 2.03629 7.46141 2.03629C7.37707 2.03629 7.29464 2.06121 7.22464 2.10789C7.15464 2.15456 7.10023 2.22086 7.06836 2.29835L5.81813 5.30163L2.5727 5.56366C2.48859 5.57099 2.40852 5.60275 2.34249 5.65497C2.27646 5.7072 2.22741 5.77757 2.20146 5.8573C2.17551 5.93703 2.17381 6.02258 2.19657 6.10326C2.21934 6.18395 2.26556 6.25618 2.32945 6.31095L4.8025 8.42736L4.04688 11.5889C4.0269 11.6702 4.03166 11.7555 4.06056 11.8342C4.08947 11.9128 4.14121 11.9811 4.20925 12.0306C4.27729 12.0801 4.35858 12.1084 4.44285 12.112C4.52711 12.1156 4.61056 12.0944 4.68266 12.0509L7.46141 10.3553Z"
				fill="#EBB700"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1713">
				<rect
					width="13"
					height="12.9"
					fill="white"
					transform="translate(0.961426 0.826904)"
				/>
			</clipPath>
		</defs>
	</svg>
);

const reviews = (
	<svg
		width="14"
		height="14"
		viewBox="0 0 14 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_2585_1717)">
			<path
				d="M2.55669 12.4223C2.49752 12.4717 2.42537 12.5033 2.34872 12.5134C2.27207 12.5235 2.19411 12.5117 2.12398 12.4794C2.05386 12.4471 1.99449 12.3955 1.95285 12.3309C1.91121 12.2662 1.88903 12.1911 1.88892 12.1144V3.05959C1.88892 2.95267 1.93172 2.85014 2.0079 2.77454C2.08409 2.69894 2.18742 2.65646 2.29517 2.65646H11.2327C11.3404 2.65646 11.4437 2.69894 11.5199 2.77454C11.5961 2.85014 11.6389 2.95267 11.6389 3.05959V10.5019C11.6389 10.6088 11.5961 10.7113 11.5199 10.7869C11.4437 10.8625 11.3404 10.905 11.2327 10.905H4.32642L2.55669 12.4223Z"
				stroke="black"
				stroke-width="0.809369"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2585_1717">
				<rect
					width="13"
					height="12.9"
					fill="white"
					transform="translate(0.263916 0.826904)"
				/>
			</clipPath>
		</defs>
	</svg>
);
const arrowLink = (
	<svg
		width="17"
		height="18"
		viewBox="0 0 17 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4.95831 12.3875L12.0416 5.3042M12.0416 5.3042H4.95831M12.0416 5.3042V12.3875"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const check = (
	<svg
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M12.1666 4L5.74992 10.4167L2.83325 7.5"
			stroke="currentColor"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const clinicArrowLink = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="21"
		height="21"
		viewBox="0 0 21 21"
		fill="none"
	>
		<path
			d="M6.33325 14.6667L14.6666 6.33337M14.6666 6.33337H6.33325M14.6666 6.33337V14.6667"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

const angleRightIcon = (
	<svg
		width="8"
		height="14"
		viewBox="0 0 8 14"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M1.52227 0.5L0 2.0275L4.94467 7L0 11.9725L1.52227 13.5L8 7L1.52227 0.5Z"
			fill="black"
		/>
	</svg>
);
const angledown = (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={2.5}
		stroke="currentColor"
		className="size-4"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="m19.5 8.25-7.5 7.5-7.5-7.5"
		/>
	</svg>
);
const plus = (
	<svg
		width="16"
		height="17"
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g>
			<path
				d="M7.99992 3.83337V13.1667M3.33325 8.50004H12.6666"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
);
const minus = (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g>
			<path
				d="M3.33325 8H12.6666"
				stroke="current"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</g>
	</svg>
);
const heart = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.5479 2.54913C14.0725 2.54913 15.7689 4.95208 15.7689 7.19376C15.7689 11.7336 8.72865 15.4509 8.60122 15.4509C8.4738 15.4509 1.43359 11.7336 1.43359 7.19376C1.43359 4.95208 3.12993 2.54913 5.65453 2.54913C7.10399 2.54913 8.0517 3.28292 8.60122 3.92801C9.15074 3.28292 10.0985 2.54913 11.5479 2.54913Z"
			fill="#FF5A5A"
		/>
	</svg>
);
const comment = (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M14.5834 8.64162C14.5834 11.7095 12.0964 14.1965 9.0285 14.1965C8.32383 14.1965 7.651 14.0656 7.03216 13.8272C7.02329 13.8238 7.01441 13.8203 7.00551 13.8169C6.90937 13.7797 6.812 13.7421 6.72387 13.7218C6.64238 13.703 6.57367 13.6938 6.4901 13.6907C6.39995 13.6872 6.30726 13.6969 6.21935 13.7061C6.21183 13.7069 6.20434 13.7076 6.1969 13.7084L2.52634 14.0878C2.50254 14.0903 2.48012 14.0926 2.45896 14.0948C2.46904 14.076 2.47975 14.0562 2.49112 14.0351L3.6635 11.8651C3.67006 11.853 3.67667 11.8408 3.68332 11.8285C3.75943 11.6883 3.83926 11.5412 3.87819 11.3882C3.91432 11.2462 3.92459 11.1259 3.91303 10.9799C3.90055 10.8221 3.84021 10.6442 3.78012 10.467C3.77447 10.4504 3.76883 10.4337 3.76322 10.4171C3.57554 9.86028 3.47359 9.2634 3.47359 8.64162C3.47359 5.57372 5.96061 3.08671 9.0285 3.08671C12.0964 3.08671 14.5834 5.57372 14.5834 8.64162Z"
			stroke="#B3B5B5"
			stroke-width="1.07514"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const arrowTopLink = (
	<svg
		width="81"
		height="80"
		viewBox="0 0 81 80"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M23.9998 56.6667L57.3331 23.3333M57.3331 23.3333H23.9998M57.3331 23.3333V56.6667"
			stroke="white"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);
const mapmarker5 = (
	<svg
		width="36"
		height="36"
		viewBox="0 0 36 36"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<rect width="36" height="36" rx="18" fill="#3DB8A9" fill-opacity="0.1" />
		<path
			d="M17.9999 18.4167C19.3806 18.4167 20.4999 17.2974 20.4999 15.9167C20.4999 14.536 19.3806 13.4167 17.9999 13.4167C16.6192 13.4167 15.4999 14.536 15.4999 15.9167C15.4999 17.2974 16.6192 18.4167 17.9999 18.4167Z"
			stroke="#9269D4"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M17.9999 26.3333C19.6666 23 24.6666 20.8486 24.6666 16.3333C24.6666 12.6514 21.6818 9.66667 17.9999 9.66667C14.318 9.66667 11.3333 12.6514 11.3333 16.3333C11.3333 20.8486 16.3333 23 17.9999 26.3333Z"
			stroke="#9269D4"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
);

export const clinicIcons = {
	check,
	arrowLink: clinicArrowLink,
	angleRight: angleRightIcon,
	angledown,
	plus,
	minus,
	heart,
	comment,
	arrowTopLink,
	mapmarker: mapmarker5,
};
export const procedure = {
	mapmarker2,
	dollar2,
	star: star2,
	reviews,
	arrowLink,
};

export const socialIcons = {
	whatsapp,
	mail,
	instagram,
	facebook,
	pinterest,
};

export const icons = {
	searchicon,
	mapmarker,
	dollar,
	searchicon2,
	calendar,
	star,
	searchIcon3,
	rightArrow,
	searchIcon4,
	user,
	hamburger,
	doctor,
	filter,
};
